export const InputNumberNotNegative = (rule, value, callback) => {
  if (value < 0) {
    callback(new Error('Input must greater than or equal to 0'));
  } else {
    callback()
  }
}
